module.exports = __webpack_public_path__ + "img/hc_pro_six_1.26338031.jpg";